import { useMemo } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from 'src/modules/auth';

export default function AuthRoutes() {
    const { isAuthenticated } = useAuth();

    return useMemo(() => (isAuthenticated ? <Outlet /> : <Navigate to={'/login'} />), [isAuthenticated]);
}
